import {
  AirwallexBalanceSnapshot,
  AirwallexBalanceSnapshotData,
  AirwallexBalanceSnapshotRepository,
  DatabaseService,
} from "../core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getAirwallexBalanceSnapshotRepository(
  databaseService: DatabaseService,
): AirwallexBalanceSnapshotRepository {
  return getGenericRepository<
    AirwallexBalanceSnapshot,
    AirwallexBalanceSnapshotData
  >(() => DatabaseCollection.AIRWALLEX_BALANCE_SNAPSHOTS, databaseService);
}
